import moment from 'moment';

import { isNonNullable } from '@qtek/shared/utils';
import { FilterBase, FilterChangeBase } from './base';

export interface DateValues {
  start?: moment.MomentInput | null;
  end?: moment.MomentInput | null;
}

export interface DateFilter extends FilterBase<DateValues> {
  type: 'date';
}

export type DateFilterChange = FilterChangeBase<DateValues, DateFilter>;

/**
 * Predicate function for date filter.
 * Returns `true` if row of data passes every filter.
 *
 * @param filters List of filter configs.
 * @param row Row of data to determine status for.
 * @param valueAccessor Function for change date in object
 */
export function dateFilter<T>(
  filters: DateFilterChange[],
  row: T,
  valueAccessor: (row: T, id: string) => any
): boolean {
  return filters.every(({ values, config }) => {
    const value = moment(valueAccessor(row, config.id));

    const isSameDateOrAfter = isNonNullable(values.start)
      ? value.isSameOrAfter(values.start)
      : true;
    const isSameOrBefore = isNonNullable(values.end)
      ? value.isSameOrBefore(values.end)
      : true;

    return isSameDateOrAfter && isSameOrBefore;
  });
}
